import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Memecoin } from '../../../../types/reducerTypes'
import { useWebSocketContext } from '../../../../contexts/WebSocketContext'
import useDataFeed from './useDataFeed'
import {
  ChartingLibraryWidgetOptions,
  ResolutionString,
  widget as TradingViewWidget,
} from '../../../../charting_library'
import { theme, useShouldShowForThreshold } from '../../../../theme'

const CustomTradingView = ({ memecoin }: { memecoin: Memecoin }) => {
  const { subscribe, unsubscribe } = useWebSocketContext()
  const datafeed = useDataFeed({
    tokenName: memecoin.tokenName,
    tokenSymbol: memecoin.tokenSymbol,
    contractAddress: memecoin.poolAddress,
  })

  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')

  // useEffect(() => {
  //   const channel = channels.poolTransactionsByAddress(poolAddress)

  //   subscribe('trading-view', channel, (message) => {
  //     dispatch(
  //       appendTransaction({
  //         transaction: message.data,
  //         cacheKey: cacheKey0,
  //       }),
  //     )
  //   })

  //   return () => {
  //     unsubscribe('trading-view', channel)
  //   }
  // }, [cacheKey0, dispatch, ordering, poolAddress, subscribe, unsubscribe])

  const chartContainerRef = useRef<HTMLDivElement>()

  const { tokenSymbol } = memecoin
  useEffect(() => {
    const widgetOptions: ChartingLibraryWidgetOptions = {
      debug: true,

      symbol: tokenSymbol,
      datafeed,
      interval: '60' as ResolutionString,
      time_frames: [
        {
          text: '1m',
          resolution: '30' as ResolutionString,
          description: '1 month',
        },
        {
          text: '5d',
          resolution: '5' as ResolutionString,
          description: '5 days',
        },
        {
          text: '1d',
          resolution: '1' as ResolutionString,
          description: '1 day',
        },
      ],
      container: chartContainerRef.current,
      library_path: '/charting_library/',

      theme: 'dark',
      locale: 'en',
      client_id: 'zap.tech',
      user_id: 'public_user_id',
      fullscreen: false,
      autosize: true,
      studies_overrides: {},

      // enabled_features: ['hide_left_toolbar_by_default'],
      disabled_features: [
        'header_compare',
        'header_symbol_search',
        'symbol_search_hot_key',
        'use_localstorage_for_settings',
        'save_chart_properties_to_local_storage',
        'hide_object_tree_and_price_scale_exchange_label',
        'items_favoriting',
        'remove_library_container_border',
        'show_right_widgets_panel_by_default',
        'create_volume_indicator_by_default',
      ],
    }

    const tvWidget = new TradingViewWidget(
      widgetOptions as ChartingLibraryWidgetOptions,
    )
    tvWidget.applyOverrides({
      //'paneProperties.background': '#202020', // We can make this peng! not for me
      'paneProperties.backgroundType': 'solid', // This ensures a solid background color     'mainSeriesProperties.lineStyle.color': theme.colors.brandPrimary,
    })

    return () => {
      tvWidget.remove()
    }
  }, [datafeed, tokenSymbol])

  return (
    <>
      <Wrapper>
        <div
          ref={chartContainerRef}
          className="TVChartContainer"
          style={{ width: '100%',
            height: isAtLeastMediumDisplaySize ? '390px' : '736px',
            borderRadius: '8px',
          }}
        />
      </Wrapper>
    </>
  )
}

export default CustomTradingView

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  .tv-lightweight-charts {
    border-radius: var(--units-8, 8px);
    max-width: 100%;
    table {
      max-width: 100%;
    }
  }
`
